module.exports = __webpack_public_path__ + "assets/img/service4.b0b661f9.png";